import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { WorkOrderPaymentForm } from './WorkOrderPaymentForm';
import { PaymentType, WorkOrderPayment, WorkOrderPaymentStatus } from '@/types/workOrder.types';

export const WorkOrderPayments = ({
  currentWorkOrderIndex,
  paymentType,
}: {
  currentWorkOrderIndex: number;
  paymentType: PaymentType;
}) => {
  const { control, watch } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: `workOrders[${currentWorkOrderIndex}].payments`,
  });

  const payments = watch(`workOrders[${currentWorkOrderIndex}].payments`) as WorkOrderPayment[];

  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="flex flex-row justify-between items-center px-1">
        <span className="text-base font-[600]">Checks</span>
      </div>

      {fields.map((field, index) => {
        const status = payments?.[index]?.status;
        const isDisabled = status === WorkOrderPaymentStatus.VOID || status === WorkOrderPaymentStatus.CASHED;

        return (
          <WorkOrderPaymentForm
            key={field.id}
            name={`workOrders[${currentWorkOrderIndex}].payments[${index}]`}
            disabled={isDisabled}
            onRemove={() => remove(index)}
            header={`Check #${index + 1}`}
            paymentType={paymentType}
          />
        );
      })}

      <Button
        type="button"
        variant="ghost"
        className="flex flex-row gap-2 items-center justify-start text-focuscolor hover:bg-transparent p-0 w-fit"
        onClick={() => {
          append({
            issueDate: null,
            reference: '',
            issuedTo: '',
            checkNumber: null,
            amount: null,
          });
        }}
      >
        <Plus className="w-4 h-4" />
        <span className="text-sm font-medium">Add Check</span>
      </Button>
    </div>
  );
};
